export default {
  "handAiImgGif":"@/assets/img/img.gif",
  "handAiImgArr":[
    require("@/assets/img/handAi/01.png"),
    require("@/assets/img/handAi/01.png"),
    require("@/assets/img/handAi/01.png"),
    require("@/assets/img/handAi/01.png"),
    require("@/assets/img/handAi/01.png"),
    require("@/assets/img/handAi/02.png"),
    require("@/assets/img/handAi/03.png"),
    require("@/assets/img/handAi/04.png"),
    require("@/assets/img/handAi/05.png"),
    require("@/assets/img/handAi/06.png"),
    require("@/assets/img/handAi/07.png"),
    require("@/assets/img/handAi/08.png"),
    require("@/assets/img/handAi/09.png"),
    require("@/assets/img/handAi/10.png"),
    require("@/assets/img/handAi/11.png"),
    require("@/assets/img/handAi/12.png"),
    require("@/assets/img/handAi/13.png"),
    require("@/assets/img/handAi/14.png"),
    require("@/assets/img/handAi/15.png"),
    require("@/assets/img/handAi/16.png"),
    require("@/assets/img/handAi/17.png"),
    require("@/assets/img/handAi/18.png"),
    require("@/assets/img/handAi/19.png"),
    require("@/assets/img/handAi/20.png"),
    require("@/assets/img/handAi/21.png"),
    require("@/assets/img/handAi/22.png"),
    require("@/assets/img/handAi/23.png"),
    require("@/assets/img/handAi/24.png"),
    require("@/assets/img/handAi/25.png"),
    require("@/assets/img/handAi/26.png"),
    require("@/assets/img/handAi/27.png"),
    require("@/assets/img/handAi/28.png"),
    require("@/assets/img/handAi/29.png"),
    require("@/assets/img/handAi/30.png"),
    require("@/assets/img/handAi/31.png"),
    require("@/assets/img/handAi/32.png"),
    require("@/assets/img/handAi/33.png"),
    require("@/assets/img/handAi/34.png"),
    require("@/assets/img/handAi/35.png"),
    require("@/assets/img/handAi/36.png"),
    require("@/assets/img/handAi/37.png"),
    require("@/assets/img/handAi/38.png"),
    require("@/assets/img/handAi/39.png"),
    require("@/assets/img/handAi/40.png"),
    require("@/assets/img/handAi/41.png"),
    require("@/assets/img/handAi/42.png"),
    require("@/assets/img/handAi/43.png"),
    require("@/assets/img/handAi/44.png"),
    require("@/assets/img/handAi/45.png"),
    require("@/assets/img/handAi/46.png"),
    require("@/assets/img/handAi/47.png"),
    require("@/assets/img/handAi/48.png"),
    require("@/assets/img/handAi/49.png"),
    require("@/assets/img/handAi/50.png"),
  ],
  "taskAiImgArr":[
    require("@/assets/img/taskAi/01.png"),
    require("@/assets/img/taskAi/01.png"),
    require("@/assets/img/taskAi/01.png"),
    require("@/assets/img/taskAi/01.png"),
    require("@/assets/img/taskAi/01.png"),
    require("@/assets/img/taskAi/01.png"),
    require("@/assets/img/taskAi/02.png"),
    require("@/assets/img/taskAi/03.png"),
    require("@/assets/img/taskAi/04.png"),
    require("@/assets/img/taskAi/05.png"),
    require("@/assets/img/taskAi/06.png"),
    require("@/assets/img/taskAi/07.png"),
    require("@/assets/img/taskAi/08.png"),
    require("@/assets/img/taskAi/09.png"),
    require("@/assets/img/taskAi/10.png"),
    require("@/assets/img/taskAi/11.png"),
    require("@/assets/img/taskAi/12.png"),
    require("@/assets/img/taskAi/13.png"),
    require("@/assets/img/taskAi/14.png"),
  ],
  "taskAiImgArr2":[
  require("@/assets/img/hand.gif")
],
}